/* eslint-disable no-console */
import { takeLatest, put } from 'redux-saga/effects';
import * as TypeActions from '../store/calendarioFeriado/actionsTypes';
import BaseService from '../services/BaseService';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import * as LoaderTypeActions from '../store/loader/actionsTypes';

function* loadMunicipioUsuario({ callback }) {
  try {
    const response = yield BaseService.get({ url: 'reports/calendario/municipio-usuario' });
    yield put({
      type: TypeActions.CALENDARIO_FERIADO_LOAD_MUNICIPIO_USUARIO_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(response.data);
  } catch (error) {
    console.log(error);
    if (callback) yield callback(null);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao identificar o município do usuário!',
    });
  }
}

function* loadCalendarioPublico({ codigosIbge, ano, callback }) {
  const ibges = (codigosIbge || []).filter(Boolean).map(String);
  if (!ibges.length) {
    return;
  }

  try {
    const url = `reports/calendario/${ano}?codigoIbge=${ibges.join(',')}`;
    const response = yield BaseService.get({ url });
    yield put({
      type: TypeActions.CALENDARIO_FERIADO_LOAD_PUBLICO_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(true, response.data);
  } catch (error) {
    console.log(error);
    let message = 'Erro ao carregar o calendário de feriados!';
    if (error.response && error.response.status === 403) {
      message = 'Sem permissão para visualizar o calendário deste município.';
    } else if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: TypeActions.CALENDARIO_FERIADO_LOAD_PUBLICO_FAIL });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message,
    });
  }
}

function* criarFeriado({ data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.post({ url: 'reports/calendario', data });
    yield put({
      type: TypeActions.CALENDARIO_FERIADO_CRIAR_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(true, response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Feriado criado com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    let message = 'Erro ao criar o feriado!';
    if (error.response && error.response.status === 403) {
      message = 'Sem permissão para criar feriados.';
    } else if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({ type: ToastTypeActions.TOAST_MESSAGE_ERROR, message });
  }
}

function* atualizarFeriado({ data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.put({ url: `reports/calendario/${data.id}`, data });
    yield put({
      type: TypeActions.CALENDARIO_FERIADO_ATUALIZAR_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(true, response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Feriado atualizado com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    let message = 'Erro ao atualizar o feriado!';
    if (error.response && error.response.status === 403) {
      message = 'Sem permissão para atualizar feriados.';
    } else if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({ type: ToastTypeActions.TOAST_MESSAGE_ERROR, message });
  }
}

function* invalidarFeriado({ id, motivo, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.post({
      url: `reports/calendario/${id}/invalidar`,
      data: { motivo },
    });
    yield put({
      type: TypeActions.CALENDARIO_FERIADO_INVALIDAR_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(true, response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Feriado invalidado com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    let message = 'Erro ao invalidar o feriado!';
    if (error.response && error.response.status === 403) {
      message = 'Sem permissão para invalidar feriados.';
    } else if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({ type: ToastTypeActions.TOAST_MESSAGE_ERROR, message });
  }
}

function* revalidarFeriado({ id, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.post({ url: `reports/calendario/${id}/revalidar` });
    yield put({
      type: TypeActions.CALENDARIO_FERIADO_REVALIDAR_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(true, response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Feriado revalidado com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    let message = 'Erro ao revalidar o feriado!';
    if (error.response && error.response.status === 403) {
      message = 'Sem permissão para revalidar feriados.';
    } else if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({ type: ToastTypeActions.TOAST_MESSAGE_ERROR, message });
  }
}

export default function* watchCalendarioFeriado() {
  yield takeLatest(TypeActions.CALENDARIO_FERIADO_LOAD_MUNICIPIO_USUARIO, loadMunicipioUsuario);
  yield takeLatest(TypeActions.CALENDARIO_FERIADO_LOAD_PUBLICO, loadCalendarioPublico);
  yield takeLatest(TypeActions.CALENDARIO_FERIADO_CRIAR, criarFeriado);
  yield takeLatest(TypeActions.CALENDARIO_FERIADO_ATUALIZAR, atualizarFeriado);
  yield takeLatest(TypeActions.CALENDARIO_FERIADO_INVALIDAR, invalidarFeriado);
  yield takeLatest(TypeActions.CALENDARIO_FERIADO_REVALIDAR, revalidarFeriado);
}
